import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/icon/course.png';
var _hoisted_1 = {
  class: "course-panel"
};
var _hoisted_2 = {
  class: "course-list"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "name"
};
var _hoisted_5 = {
  class: "main"
};
var _hoisted_6 = {
  key: 0,
  class: "course-panel-box"
};
var _hoisted_7 = {
  class: "course-panel-main"
};
var _hoisted_8 = {
  class: "dialog-course"
};
import CourseDemo from './CourseDemo';
import SaveCourseDialog from './SaveCourseDialog';
import SideBar from '../common/SideBar';
import Empty from '../common/Empty';
import CanvasPanel from '../common/CanvasPanel';
import CanvasTool from '../common/CanvasTool/index';
import ChangeRole from '../common/ChangeRole';
import ChoiseCourse from '../common/ChoiseCourse';

/* 工具 */
import { ref, onMounted, inject, provide, computed, nextTick } from 'vue';
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { LEFT_BAR_MAP } from '../../const';
import { operationRecord } from '../common/common';
import { getStore } from '@/util/store';
import { getEnvName, getHostName } from '@/util/env';
import useSocket from '../common/useSocket.js';

/* api */
import { getCourseResearch, delResearchCourse, addResearchCourse, getCourseCanvas, addEditCourseDraw, removeCourseDraw } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'index',
  setup: function setup(__props) {
    var _getStore, _getStore2;
    /* 组件 */
    var userId = (_getStore = getStore({
      name: 'userInfo'
    })) === null || _getStore === void 0 ? void 0 : _getStore.id;
    var userName = (_getStore2 = getStore({
      name: 'userInfo'
    })) === null || _getStore2 === void 0 ? void 0 : _getStore2.name;
    var canvasPanelRef = ref();
    var discussId = inject('discussId');
    var discussInfo = inject('discussInfo');
    var courseList = ref([]); // 学程列表
    var currentCourseInfo = ref({}); // 当前学程信息
    var courseDemoShow = ref(false);
    var canvasShow = ref(false);
    var canvasObj = ref({});
    var canvasW = ref(0);
    var canvasH = ref(0);
    var roleId = ref(userId);
    var addCourseVisible = ref(false);
    var confirmLoading = ref(false);
    var checkedList = ref([]);
    var saveCourseShow = ref(false);
    var _useSocket = useSocket(32, discussId.value),
      socketSend = _useSocket.socketSend,
      socketReceive = _useSocket.socketReceive;

    /* 计算属性 */
    // 当前是否为创建者
    var isCreator = computed(function () {
      var _discussInfo$value;
      return userId === ((_discussInfo$value = discussInfo.value) === null || _discussInfo$value === void 0 ? void 0 : _discussInfo$value.creatorId);
    });
    var checkCourseId = computed(function () {
      var _courseList$value;
      return (_courseList$value = courseList.value) === null || _courseList$value === void 0 ? void 0 : _courseList$value.map(function (e) {
        return e.courseId;
      });
    });

    /* 传递数据 */
    provide('annotation-type', 'course');
    provide('annotation-info', currentCourseInfo);
    provide('annotation-roleId', roleId);

    /* 事件 */
    // 获取学程列表
    var getList = function getList() {
      getCourseResearch(discussId.value).then(function (res) {
        if (res.data.code === 0) {
          courseList.value = res.data.data;
          if (res.data.data.length) {
            var index = res.data.data.findIndex(function (e) {
              var _currentCourseInfo$va;
              return e.courseId === ((_currentCourseInfo$va = currentCourseInfo.value) === null || _currentCourseInfo$va === void 0 ? void 0 : _currentCourseInfo$va.courseId);
            });
            if (index === -1) {
              courseChange(res.data.data[0]);
            }
          } else {
            currentCourseInfo.value = {};
          }
        }
      });
    };

    // 删除学程
    var courseDelete = function courseDelete(id) {
      var dialog = DialogPlugin({
        header: '删除关联学程',
        body: '是否删除该关联学程',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function onConfirm() {
          delResearchCourse(discussId.value, id).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('删除成功！');
              getList();
              dialog.destroy();
            }
          });
        }
      });
    };

    // 切换学程
    var courseChange = function courseChange(item) {
      var _currentCourseInfo$va2;
      if (!item || ((_currentCourseInfo$va2 = currentCourseInfo.value) === null || _currentCourseInfo$va2 === void 0 ? void 0 : _currentCourseInfo$va2.courseId) === (item === null || item === void 0 ? void 0 : item.courseId)) return;
      courseDemoShow.value = false;
      canvasShow.value = false;
      currentCourseInfo.value = item;
      nextTick(function () {
        courseDemoShow.value = true;
      });
      operationRecord(discussId.value, '查看学程');
    };

    // 侧边栏点击
    var sideBarChange = function sideBarChange(item) {
      if (item.click === 'courseAdd') {
        addCourseVisible.value = true;
      }
    };

    // 点击跳转学程
    var toCourseDetail = function toCourseDetail() {
      var _currentCourseInfo$va3;
      var env_name = getEnvName();
      var hostName = getHostName();
      window.open("//".concat(env_name || 'edu-', "course.").concat(hostName, "/edit?from=research&type=groupedit&courseId=").concat((_currentCourseInfo$va3 = currentCourseInfo.value) === null || _currentCourseInfo$va3 === void 0 ? void 0 : _currentCourseInfo$va3.courseId, "&version=2&autyType=2"));
      operationRecord(discussId.value, '编辑学程');
    };

    // 添加学程弹窗关闭
    var addCourseClose = function addCourseClose() {
      checkedList.value = [];
    };

    // 添加学程
    var addCourseOk = function addCourseOk() {
      if (checkedList.value.length) {
        confirmLoading.value = true;
        addResearchCourse({
          discussId: discussId.value,
          courses: checkedList.value.map(function (e) {
            return {
              courseId: e.id,
              title: e.title,
              version: e.version,
              source: e.source,
              dataJson: e.dataJson
            };
          })
        }).then(function (res) {
          if (res.data.code === 0) {
            confirmLoading.value = false;
            addCourseVisible.value = false;
            MessagePlugin.success('学程添加成功！');
            checkedList.value = [];
            getList();
          }
        });
      } else {
        MessagePlugin.closeAll();
        MessagePlugin.warning('请选择学程');
      }
    };

    // 学程加载完成
    var courseDemoLoaded = function courseDemoLoaded(w, h) {
      canvasW.value = w;
      canvasH.value = h;
      canvasShow.value = true;
      nextTick(function () {
        getCanvas();
      });
    };

    // 获取画布内容
    var getCanvas = function getCanvas() {
      return new Promise(function (resolve) {
        var _canvasObj$value, _currentCourseInfo$va4;
        (_canvasObj$value = canvasObj.value) === null || _canvasObj$value === void 0 || _canvasObj$value.clear();
        var data = {
          discussId: discussId.value,
          // 教研id
          courseResearchId: (_currentCourseInfo$va4 = currentCourseInfo.value) === null || _currentCourseInfo$va4 === void 0 ? void 0 : _currentCourseInfo$va4.id,
          // 学程关联id
          viewerId: roleId.value // 视角id
        };
        getCourseCanvas(data).then(function (res) {
          if (res.data.code === 0) {
            var _canvasPanelRef$value;
            (_canvasPanelRef$value = canvasPanelRef.value) === null || _canvasPanelRef$value === void 0 || _canvasPanelRef$value.addElements(res.data.data || []);
            resolve();
          }
        });
      });
    };

    // 视角切换
    var roleChange = function roleChange() {
      getCanvas();
    };

    // 画布工具切换
    var toolChange = function toolChange(toolInfo) {
      if (toolInfo.tool === 'save-course') {
        saveCourseShow.value = true;
      } else {
        var _canvasPanelRef$value2;
        (_canvasPanelRef$value2 = canvasPanelRef.value) === null || _canvasPanelRef$value2 === void 0 || _canvasPanelRef$value2.toolChange(toolInfo);
      }
    };

    // 画布内容改变
    var canvasChange = function canvasChange(data) {
      var addOpts = ['penciladd', 'textadd', 'textedit', 'markadd'];
      var delOpts = ['pencildel', 'textdel', 'markdel'];
      var api = null;
      if (addOpts.includes(data.optType)) {
        var _currentCourseInfo$va5, _currentCourseInfo$va6;
        var params = {
          discussId: discussId.value,
          courseResearchId: (_currentCourseInfo$va5 = currentCourseInfo.value) === null || _currentCourseInfo$va5 === void 0 ? void 0 : _currentCourseInfo$va5.id,
          courseId: (_currentCourseInfo$va6 = currentCourseInfo.value) === null || _currentCourseInfo$va6 === void 0 ? void 0 : _currentCourseInfo$va6.courseId,
          drawId: data.drawId,
          drawContent: data.drawContent,
          viewerId: roleId.value,
          ownerId: userId
        };
        api = addEditCourseDraw(params);
      } else if (delOpts.includes(data.optType)) {
        api = removeCourseDraw(discussId.value, data.drawId);
      }
      if (api) {
        api.then(function (res) {
          if (res.data.code === 0) {
            var _currentCourseInfo$va7, _currentCourseInfo$va8;
            var txt = '';
            if (data.optType === 'penciladd') {
              txt = '学程—使用画笔';
            } else if (data.optType === 'textadd') {
              txt = '学程—使用文本框';
            } else if (data.optType === 'pencildel' || data.optType === 'textdel') {
              txt = '学程—使用橡皮擦';
            }
            txt && operationRecord(discussId.value, txt);
            socketSend({
              msgType: 13,
              bizType: 32,
              userId: userId,
              userName: userName,
              bizId: discussId.value,
              optType: data.optType,
              optData: {
                discussId: discussId.value,
                courseResearchId: (_currentCourseInfo$va7 = currentCourseInfo.value) === null || _currentCourseInfo$va7 === void 0 ? void 0 : _currentCourseInfo$va7.id,
                courseId: (_currentCourseInfo$va8 = currentCourseInfo.value) === null || _currentCourseInfo$va8 === void 0 ? void 0 : _currentCourseInfo$va8.courseId,
                viewerId: roleId.value
              }
            });
          }
        });
      }
    };

    /* 钩子 */
    onMounted(function () {
      socketReceive(function (data) {
        if (data.optData) {
          var _currentCourseInfo$va9, _currentCourseInfo$va0;
          var ids = JSON.parse(data.optData);
          var _discussId = ids.discussId,
            documentId = ids.documentId,
            documentItemId = ids.documentItemId,
            viewerId = ids.viewerId;
          var bool1 = Number(_discussId) === Number(_discussId.value);
          var bool2 = Number(documentId) === Number((_currentCourseInfo$va9 = currentCourseInfo.value) === null || _currentCourseInfo$va9 === void 0 ? void 0 : _currentCourseInfo$va9.id);
          var bool3 = Number(documentItemId) === Number((_currentCourseInfo$va0 = currentCourseInfo.value) === null || _currentCourseInfo$va0 === void 0 ? void 0 : _currentCourseInfo$va0.courseId);
          var bool4 = Number(viewerId) === Number(roleId.value);
          if (bool1 && bool2 && bool3 && bool4) {
            getCanvas();
          }
        }
      });
      getList();
    });
    return function (_ctx, _cache) {
      var _currentCourseInfo$va1, _currentCourseInfo$va10;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(SideBar), {
        barList: _unref(LEFT_BAR_MAP)['course'],
        onTabChange: sideBarChange,
        onHoverEnter: getList
      }, {
        hoverList: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "course-item",
              onClick: function onClick($event) {
                return courseChange(item);
              }
            }, [_cache[5] || (_cache[5] = _createElementVNode("img", {
              width: "18",
              height: "24",
              src: _imports_0
            }, null, -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1), isCreator.value ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 0,
              name: "delete",
              onClick: _withModifiers(function ($event) {
                return courseDelete(item.id);
              }, ["stop"])
            }, null, 8, ["onClick"])) : _createCommentVNode("", true)], 8, _hoisted_3);
          }), 128))])];
        }),
        _: 1
      }, 8, ["barList"]), _createElementVNode("div", _hoisted_5, [courseDemoShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        class: "go-course-edit",
        onClick: toCourseDetail
      }, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "去编辑", -1)), _createVNode(_component_svg_icon, {
        name: "chevron-right"
      })]), _createElementVNode("div", _hoisted_7, [_createVNode(_unref(CourseDemo), {
        courseId: (_currentCourseInfo$va1 = currentCourseInfo.value) === null || _currentCourseInfo$va1 === void 0 ? void 0 : _currentCourseInfo$va1.courseId,
        onLoaded: courseDemoLoaded
      }, null, 8, ["courseId"]), canvasShow.value ? (_openBlock(), _createBlock(_unref(CanvasPanel), {
        key: 0,
        ref_key: "canvasPanelRef",
        ref: canvasPanelRef,
        canvasObj: canvasObj.value,
        "onUpdate:canvasObj": _cache[0] || (_cache[0] = function ($event) {
          return canvasObj.value = $event;
        }),
        w: canvasW.value,
        h: canvasH.value,
        onChange: canvasChange
      }, null, 8, ["canvasObj", "w", "h"])) : _createCommentVNode("", true)]), _createVNode(_unref(ChangeRole), {
        modelValue: roleId.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return roleId.value = $event;
        }),
        onChange: roleChange
      }, null, 8, ["modelValue"]), _createVNode(_unref(CanvasTool), {
        tools: ['brush', 'rubber', 'text', 'note', 'save-course'],
        onChange: toolChange
      })])) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        name: "course"
      }))]), _createVNode(_component_t_dialog, {
        header: "添加学程",
        visible: addCourseVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return addCourseVisible.value = $event;
        }),
        destroyOnClose: "",
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        confirmLoading: confirmLoading.value,
        onConfirm: addCourseOk,
        onClose: addCourseClose
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_8, [_cache[7] || (_cache[7] = _createElementVNode("div", {
            class: "dialog-course-item"
          }, "我的学程", -1)), addCourseVisible.value ? (_openBlock(), _createBlock(_unref(ChoiseCourse), {
            key: 0,
            checked: checkedList.value,
            "onUpdate:checked": _cache[2] || (_cache[2] = function ($event) {
              return checkedList.value = $event;
            }),
            disableId: checkCourseId.value,
            onlyNewCourse: ""
          }, null, 8, ["checked", "disableId"])) : _createCommentVNode("", true)])];
        }),
        _: 1
      }, 8, ["visible", "confirmLoading"]), _createVNode(_unref(SaveCourseDialog), {
        visible: saveCourseShow.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = function ($event) {
          return saveCourseShow.value = $event;
        }),
        courseId: (_currentCourseInfo$va10 = currentCourseInfo.value) === null || _currentCourseInfo$va10 === void 0 ? void 0 : _currentCourseInfo$va10.courseId
      }, null, 8, ["visible", "courseId"])]);
    };
  }
};